import { FC } from 'react';
import { TFileData } from '@/models/fileUpload';
import { DEFAULT_HEADER } from '../createDataSource/createDataSourceContent/dataSourceTypes/file/constants';
import { CSVTable } from '../createDataSource/createDataSourceContent/dataSourceTypes/file/commons/table';

type CSVFileDataTableProps = {
  csvFileData?: TFileData;
  csvHeader: string;
};

export const CSVFileDataTable: FC<CSVFileDataTableProps> = ({ csvFileData, csvHeader }) => {
  if (!csvFileData) {
    return null;
  }

  return (
    <div className='flex flex-col overflow-x-auto'>
      <CSVTable fileContent={csvFileData.preview} fileHeaders={csvFileData.header} isDefaultHeaderCorrect={csvHeader === DEFAULT_HEADER} />
    </div>
  );
};
